module.exports = __webpack_public_path__ + "static/media/Guide_Conecta_Pedidos.9926b840.pdf";